import React from 'react';
import './Spinner.css';
import bubble from '../../Assets/Images/myuti-bubble.png';

const Spinner = props => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 20,
      }}
    >
      <img
        className="iconOrbLeft"
        style={{ height: 43, width: 43, marginRight: 10 }}
        src={bubble}
        alt="logoScr"
      />
      <div className="loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
